(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["edg-build-commerce"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';
  const rootSelector = '[data-edg-traditional-builder], [data-edg-standard-martingale-builder], [data-edg-arctic-builder], [data-edg-canvas-builder]';
  let config;
  let scheduled = false;
  function settings() {
    if (!config) {
      const node = document.querySelector('[data-edg-commerce-config]');
      if (node) config = JSON.parse(node.textContent);
    }
    return config;
  }
  function money(cents) {
    return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style: 'currency', currency: settings().currency}).format(cents / 100);
  }
  function linkedItems(root, source) {
    const items = source.map(item => Object.assign({}, item, { properties: Object.assign({}, item.properties) }));
    const collar = items[0];
    if (root.matches('[data-edg-standard-martingale-builder]')) {
      collar.properties['Open-slide name tag'] = window.EDGTagReview?.selected(root, false)?.some(tag => tag.kind === 'slide') ? 'Yes' : 'No';
    }
    const anchor = root.querySelector('[data-edg-anchor-toggle]');
    if (anchor) {
      collar.properties['ID Anchor'] = anchor.checked ? 'Yes' : 'No';
      if (anchor.checked) {
        if (!Number(anchor.dataset.anchorId) || anchor.disabled || anchor.dataset.anchorAvailable !== 'true') throw new Error(settings().labels.anchorUnavailable);
        if (!items.some(item => Number(item.id) === Number(anchor.dataset.anchorId))) items.push({id: Number(anchor.dataset.anchorId), quantity: collar.quantity || 1, properties: {'_EDG Feature': 'ID Anchor', '_EDG Collar Bundle': String(collar.id), 'Built into collar': 'Yes'}});
      }
    }

    const nightguard = root.querySelector('[data-edg-nightguard-toggle]');
    if (nightguard) {
      collar.properties['NightGuard Reflective Edge'] = nightguard.checked ? 'Yes' : 'No';
      if (nightguard.checked) {
        if (!Number(nightguard.dataset.nightguardId) || nightguard.disabled || nightguard.dataset.nightguardAvailable !== 'true') throw new Error(settings().labels.nightguardUnavailable);
        items.push({id: Number(nightguard.dataset.nightguardId), quantity: collar.quantity || 1, properties: {'_EDG Feature': 'NightGuard Reflective Edge', '_EDG Collar Bundle': String(collar.id), 'Built into collar': 'Yes'}});
      }
    }
    if (root.querySelector('[data-edg-tag-review]')) {
      if (!window.EDGTagReview) throw new Error(settings().labels.tagsLoading);
      window.EDGTagReview.cartItems(root).forEach(item => {
        item.properties['_EDG Collar Bundle'] = String(collar.id);
        items.push(item);
      });
    }
    if (window.EDGSizing) collar.properties = window.EDGSizing.properties(root, collar.properties);
    collar.properties['_EDG Builder'] = JSON.stringify(window.EDGBuildEditor.capture(root));
    if('edgEditDogName' in root.dataset)collar.properties['Dog name']=root.dataset.edgEditDogName;
    const group = crypto.randomUUID();
    collar.properties['_EDG Build'] = group;
    collar.properties['_EDG Role'] = 'collar';
    collar.properties['_EDG Extras'] = JSON.stringify(items.slice(1).map(item => Number(item.id)));
    items.slice(1).forEach(item => {
      item.parent_id = Number(collar.id);
      item.quantity = Number(collar.quantity) || 1;
      item.properties['_EDG Build'] = group;
      item.properties['_EDG Role'] = 'extra';
    });
    return items;
  }
  function withIdAnchor(root, collar) {
    return linkedItems(root, [collar]);
  }
  function selectedExtras(root) {
    const result = [];
    const labels = settings().labels;
    const nightguard = root.querySelector('[data-edg-nightguard-toggle]');
    if (nightguard && nightguard.checked) result.push({label: labels.nightguard, price: Number(nightguard.dataset.nightguardPrice)});
    const toggle = root.querySelector('[data-edg-anchor-toggle]');
    if (toggle && toggle.checked) result.push({label: labels.anchor, price: Number(toggle.dataset.anchorPrice)});
    if (root.matches('[data-edg-standard-martingale-builder]')) {
      function add(label, id) {
        const variant = settings().extras.find(item => Number(item.id) === Number(id));
        if (!variant) return false;
        result.push({label, price: variant.price});
        return true;
      }
      if (root.dataset.closure === 'buckle' && !add(labels.buckle, root.dataset.buckleVariant)) return null;
      if (root.dataset.idAnchor === 'yes' && !add(labels.anchor, root.dataset.idAnchorVariant)) return null;
      if (root.dataset.openSlideTag === 'yes' && !add(labels.tag, root.dataset.openSlideTagVariant)) return null;
      const chain = document.querySelector('[data-edg-martingale-chain]');
      if (chain && chain.querySelector('[data-loop="chain"]:checked')) {
        const width = root.dataset.webbingWidth || '';
        const id = /3\s*\/\s*4|¾/.test(width) ? chain.dataset.threeQuarterId : chain.dataset.oneInchId;
        if (!add(labels.chain, id)) return null;
      }
    }
    if (root.querySelector('[data-edg-tag-review]')) {
      if (!window.EDGTagReview) return null;
      const tags = window.EDGTagReview.selected(root, false);
      if (!tags) return null;
      tags.forEach(tag => result.push({label: tag.label, price: tag.price}));
    }
    return result;
  }
  function write(node, value) { if (node && node.textContent !== value) node.textContent = value; }
  function refresh(root) {
    if (!root || root.hidden || !settings()) return;
    write(root.querySelector('[data-edg-addon-context]'), [root.dataset.sizeValue,root.dataset.webbingWidth||(root.matches('[data-edg-canvas-builder]')?'1 inch':''),root.dataset.nativeFiSeries||root.dataset.nativeWidthValue||root.dataset.fiValue,root.dataset.colorValue||root.dataset.patternValue].filter(Boolean).join(' · '));
    const box = root.querySelector('[data-edg-build-price]');
    if (!box) return;
    const variant = window.EDGCheckoutIntegrity && window.EDGCheckoutIntegrity.exactVariant(root);
    const extras = selectedExtras(root);
    const labels = settings().labels;
    const ready = variant && Number.isFinite(variant.price) && extras;
    const lines = ready ? [{label: labels.base, price: variant.price}].concat(extras) : [];
    const total = ready ? lines.reduce((sum, line) => sum + line.price, 0) : null;
    const key = JSON.stringify([lines, total]);
    if (box.dataset.priceKey !== key) {
      box.dataset.priceKey = key;
      box.replaceChildren();
      if (!ready) {
        const p = document.createElement('p'); p.textContent = labels.pending; box.appendChild(p);
      } else {
        lines.concat([{label: labels.subtotal, price: total}]).forEach(line => {
          const row = document.createElement('div'); row.className = 'edg-build-price__line' + (line.label === labels.subtotal ? ' edg-build-price__line--total' : '');
          const name = document.createElement('span'); name.textContent = line.label;
          const value = document.createElement('span'); value.textContent = money(line.price);
          row.append(name, value); box.appendChild(row);
        });
        const p = document.createElement('p'); p.className = 'edg-build-price__note'; p.textContent = labels.excluding; box.appendChild(p);
      }
    }
    const headline = document.querySelector('[data-edg-identity-price]');
    write(headline, ready ? money(total) : labels.from.replace('[price]', money(settings().basePrice)));
    write(document.querySelector('[data-edg-price-caption]'), ready ? labels.subtotal : '');
    const anchorSummary = root.querySelector('[data-review-anchor]');
    const toggle = root.querySelector('[data-edg-anchor-toggle]');
    if (anchorSummary) write(anchorSummary, toggle && toggle.checked ? labels.anchor + ' — +' + money(Number(toggle.dataset.anchorPrice)) : '—');
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; document.querySelectorAll(rootSelector).forEach(refresh); });
  }
  function init() {
    if (!settings()) return;
    document.querySelectorAll(rootSelector).forEach(root => {
      if (root.dataset.commerceReady) return;
      root.dataset.commerceReady = 'true';
      root.addEventListener('change', schedule);
      root.addEventListener('click', () => { schedule(); [200, 600, 1500].forEach(delay => setTimeout(schedule, delay)); });
      new MutationObserver(schedule).observe(root, {attributes: true, attributeFilter: ['hidden','data-size-value','data-color-value','data-pattern-value','data-id-anchor','data-open-slide-tag','data-webbing-width','data-native-fi-series','data-fi-value','data-closure','data-chain']});
      refresh(root);
    });
    const picker = document.querySelector('.variant-selects-main');
    const container = picker && picker.closest('.section-product-info');
    if (container && !container.dataset.commerceObserved) {
      container.dataset.commerceObserved = 'true';
      new MutationObserver(schedule).observe(container, {childList: true, subtree: true, characterData: true});
    }
  }
  window.EDGBuildCommerce = {withIdAnchor, linkedItems, refresh};
  document.addEventListener('eurus:variant:change', schedule);
  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["edg-fi-selector"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';
  function modelOf(value) { return /Series\s*2/i.test(value) ? '2' : /Series\s*3/i.test(value) ? '3' : ''; }
  function widthOf(value) { return /3\s*\/\s*4\s*inch/i.test(value) ? '3/4 inch' : /\b1\s*inch/i.test(value) ? '1 inch' : ''; }
  function resolve(options, model, width, fixed) {
    if (!['2','3'].includes(model) || !['1 inch','3/4 inch'].includes(width) || (fixed && width !== fixed)) return null;
    return options.find(option => modelOf(option.value) === model && (widthOf(option.value) === width || (!widthOf(option.value) && (model === '2' || fixed === width)))) || null;
  }
  function init() {
    document.querySelectorAll('[data-edg-fi-selector]').forEach(panel => {
      if (panel.dataset.ready) return;
      panel.dataset.ready = 'true';
      const config = JSON.parse(panel.querySelector('[data-edg-fi-options]').textContent);
      const root = panel.closest('[data-edg-traditional-builder], [data-edg-arctic-builder], [data-edg-standard-martingale-builder], [data-edg-canvas-builder]');
      const models = [...panel.querySelectorAll('[data-edg-fi-model]')], widths = [...panel.querySelectorAll('[data-edg-fi-webbing]')];
      const fixed = panel.dataset.fixedWidth || '';
      const error = panel.querySelector('[data-edg-fi-error]');
      let model = '';
      function send(width) {
        const match = resolve(config.options, model, width, fixed);
        if (width && !match) { error.hidden = false; return false; }
        const modelLabel = model === '3' ? config.model3 : config.model2;
        const detail = {model,modelLabel,width:match ? width : '',option:match ? match.option : '',value:match ? match.value : '',summary:modelLabel + (match ? ' · ' + config.widthLabel.replace('[width]',width) : ''),applied:false};
        root.dispatchEvent(new CustomEvent('edg:fi-selection',{detail}));
        error.hidden = detail.applied;
        return detail.applied;
      }
      models.forEach(button => {
        button.hidden = !config.options.some(option => modelOf(option.value) === button.dataset.edgFiModel);
        button.addEventListener('click',() => {
          const next = button.dataset.edgFiModel;
          if (next === model) { if (fixed) send(fixed); return; }
          model = next;
          models.forEach(item => item.setAttribute('aria-pressed',String(item === button)));
          widths.forEach(item => { item.setAttribute('aria-pressed','false'); item.hidden = !resolve(config.options, model, item.dataset.edgFiWebbing, fixed); });
          panel.querySelector('[data-edg-fi-width-panel]').hidden = false;
          send(fixed);
        });
      });
      widths.forEach(button => button.addEventListener('click',() => {
        if (model && send(button.dataset.edgFiWebbing)) widths.forEach(item => item.setAttribute('aria-pressed',String(item === button)));
      }));
      new MutationObserver(() => {
        if (!root.dataset.webbingWidth) widths.forEach(button => button.setAttribute('aria-pressed','false'));
      }).observe(root,{attributes:true,attributeFilter:['data-webbing-width']});
    });
  }
  window.EDGFiSelector = {resolve,modelOf,widthOf};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init); else init();
  document.addEventListener('shopify:section:load',init);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["edg-linked-cart"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';
  if (window.EDGLinkedCart) return;
  let queue = Promise.resolve();
  let pending = 0;
  let replaying = false;
  let checkingOut = false;
  let checkoutBlocked = false;
  const strings = () => JSON.parse(document.querySelector('[data-edg-linked-cart-strings]').textContent);
  const base = () => window.Shopify?.routes?.root || '/';
  const groupOf = item => item.properties?.['_EDG Build'];
  const roleOf = item => item.properties?.['_EDG Role'];
  const parentOf = (cart, group) => cart.items.find(item => groupOf(item) === group && roleOf(item) === 'collar');
  const childrenOf = (cart, group) => cart.items.filter(item => groupOf(item) === group && roleOf(item) === 'extra');
  function syncExpressCheckout() {
    document.querySelectorAll('[data-edg-express-checkout]').forEach(element => { element.inert = pending > 0 || checkoutBlocked; });
  }
  function groupForKey(key) {
    const input = document.getElementById('cart-qty-' + key);
    return input?.closest('[data-edg-linked-build]')?.dataset.edgLinkedBuild || '';
  }
  function audit(cart) {
    if (!Array.isArray(cart?.items)) throw new Error(strings().refresh);
    for (const item of cart.items) {
      const group = groupOf(item);
      if (!group) continue;
      const parent = parentOf(cart, group);
      if (!parent) throw new Error(strings().incomplete);
      if (roleOf(item) === 'extra') {
        if (item.parent_relationship?.parent_key !== parent.key) throw new Error(strings().incomplete);
        continue;
      }
      if (roleOf(item) !== 'collar') throw new Error(strings().incomplete);
      let expected;
      try { expected = JSON.parse(parent.properties['_EDG Extras']); } catch (_) { throw new Error(strings().incomplete); }
      const children = childrenOf(cart, group);
      if (!Array.isArray(expected) || expected.length !== children.length) throw new Error(strings().incomplete);
      const remaining = expected.map(Number);
      for (const child of children) {
        const index = remaining.indexOf(Number(child.variant_id));
        if (index < 0 || child.quantity !== parent.quantity) throw new Error(strings().incomplete);
        remaining.splice(index, 1);
      }
    }
    return cart;
  }
  async function request(path, payload) {
    const response = await fetch(base() + path, payload ? {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(payload)
    } : { headers: { 'Accept': 'application/json' }, cache: 'no-store' });
    const data = await response.json();
    if (!response.ok || data.status >= 400 || data.errors) throw new Error(strings().update_error);
    return data;
  }
  async function setGroupQuantity(cart, group, quantity, sections) {
    const parent = parentOf(cart, group);
    if (!parent) throw new Error(strings().incomplete);
    if (quantity === 0) {
      const result = await request('cart/change.js', Object.assign({ id: parent.key, quantity: 0 }, sections));
      if (result.items.some(item => groupOf(item) === group)) throw new Error(strings().incomplete);
      return result;
    }
    const children = childrenOf(cart, group);
    const operations = [];
    if (quantity > parent.quantity) operations.push({ role: 'collar', id: parent.variant_id });
    children.forEach(item => { if (item.quantity !== quantity) operations.push({ role: 'extra', id: item.variant_id, tag: item.properties?.['_EDG Tag'] || '' }); });
    if (quantity <= parent.quantity || !operations.length) operations.push({ role: 'collar', id: parent.variant_id });
    for (let index = 0; index < operations.length; index++) {
      const operation = operations[index];
      const line = cart.items.find(item => groupOf(item) === group && roleOf(item) === operation.role && Number(item.variant_id) === Number(operation.id) && (!operation.tag || item.properties?.['_EDG Tag'] === operation.tag));
      if (!line) throw new Error(strings().incomplete);
      const payload = { id: line.key, quantity };
      if (index === operations.length - 1) Object.assign(payload, sections);
      cart = await request('cart/change.js', payload);
      const updated = cart.items.find(item => groupOf(item) === group && roleOf(item) === operation.role && Number(item.variant_id) === Number(operation.id) && (!operation.tag || item.properties?.['_EDG Tag'] === operation.tag));
      if (!updated || updated.quantity !== quantity) throw new Error(strings().unavailable);
    }
    return cart;
  }
  function showError(message) {
    let box = document.querySelector('[data-edg-linked-cart-error]');
    if (!box) {
      box = document.createElement('p');
      box.setAttribute('data-edg-linked-cart-error', '');
      box.setAttribute('role', 'alert');
      const button = document.querySelector('[name="checkout"]');
      (button?.parentElement || document.querySelector('main') || document.body).appendChild(box);
    }
    box.textContent = message || '';
    box.hidden = !message;
  }
  async function change(controller, key, line, quantity, group) {
    const helper = window.Alpine.store('xCartHelper');
    await helper.waitForCartUpdate();
    window.updatingCart = true;
    const sections = { sections: helper.getSectionsToRender().map(section => section.id), sections_url: window.location.pathname };
    let before;
    let result;
    let message = '';
    try {
      if (!Number.isInteger(quantity) || quantity < 0) throw new Error(strings().update_error);
      before = audit(await request('cart.js'));
      if (!parentOf(before, group)) throw new Error(strings().incomplete);
      result = audit(await setGroupQuantity(before, group, quantity, sections));
    } catch (_) {
      message = strings().refresh;
      try {
        const current = await request('cart.js');
        const previous = before && parentOf(before, group);
        if (previous && parentOf(current, group)) {
          result = audit(await setGroupQuantity(current, group, previous.quantity, sections));
          message = strings().unavailable;
        } else if (quantity === 0 && !current.items.some(item => groupOf(item) === group)) {
          audit(current);
          controller.loading = false;
          window.updatingCart = false;
          window.location.reload();
          return;
        }
      } catch (_) { result = null; }
    }
    try {
      checkoutBlocked = !result;
      if (result) {
        const parent = parentOf(result, group);
        const nextLine = parent ? result.items.indexOf(parent) + 1 : line;
        if (!result.sections || !Object.keys(result.sections).length || Object.values(result.sections).some(html => typeof html !== 'string')) {
          window.location.reload();
          return;
        }
        controller.updateCartUI(result, parent?.key || key, nextLine, parent?.quantity || 0);
      }
      showError(message);
    } finally {
      controller.loading = false;
      window.updatingCart = false;
    }
  }
  function update(controller, key, line, quantity) {
    const group = groupForKey(key);
    if (!group) return;
    controller.loading = true;
    pending++;
    syncExpressCheckout();
    queue = queue.then(() => change(controller, key, line, quantity, group)).catch(() => {
      controller.loading = false;
      window.updatingCart = false;
      checkoutBlocked = true;
      showError(strings().refresh);
    }).finally(() => { pending--; syncExpressCheckout(); });
    return queue;
  }
  async function ready() {
    while (pending) await queue;
    if (window.Alpine) await window.Alpine.store('xCartHelper').waitForCartUpdate();
    try {
      const cart = audit(await request('cart.js'));
      checkoutBlocked = false;
      return cart;
    } catch (error) {
      checkoutBlocked = true;
      throw error;
    } finally { syncExpressCheckout(); }
  }
  function needsCheck() {
    return pending > 0 || Boolean(document.querySelector('[data-edg-linked-build]:not([data-edg-linked-build=""])'));
  }
  function guard(event) {
    if (replaying || !needsCheck()) return;
    const submit = event.type === 'submit';
    const button = submit ? event.submitter : event.target.closest('[name="checkout"], a[href*="/checkout"]');
    if (!button || (submit && button.name !== 'checkout')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (checkingOut) return;
    checkingOut = true;
    const form = submit ? event.target : null;
    ready().then(() => {
      showError('');
      replaying = true;
      try {
        if (form?.isConnected) form.requestSubmit(button);
        else if (button.isConnected) button.click();
        else document.querySelector('[name="checkout"]')?.click();
      } finally { replaying = false; }
    }).catch(error => showError(error.message || strings().refresh)).finally(() => { checkingOut = false; });
  }
  window.EDGLinkedCart = { isLinked: key => Boolean(groupForKey(key)), update, ready, audit, setGroupQuantity };
  document.addEventListener('click', guard, true);
  document.addEventListener('submit', guard, true);
})();
  } catch(e) { console.error(e); }
})();

})();
